import { HStack } from '@chakra-ui/react';

import InformationModule, { InformationModuleProps } from './InformationModule';
import MetricsModule, { MetricsModuleProps } from './MetricsModule';
import OperatingModule, { OperatingModuleProps } from './OperatingModule';

type Props = MetricsModuleProps & OperatingModuleProps & InformationModuleProps;

export default function Section({
  operatingValues,
  metricsValues,
  metricsComponent,
  informationValues,
}: Readonly<Props>) {
  return (
    <HStack width="100%" height="min-content" gap={0.25} backgroundColor="neutral.800">
      <OperatingModule operatingValues={operatingValues} />
      <MetricsModule metricsValues={metricsValues} metricsComponent={metricsComponent} />
      <InformationModule informationValues={informationValues} />
    </HStack>
  );
}
